const MODEL_NAME = 'good'
export default [
  {
    path: `/${MODEL_NAME}/qualityReport`,
    name: 'qualityReport',
    component: () =>
      import(/* webpackChunkName: "channel-coupon" */ '@pages/good/qualityReport/index.vue')
  }
]
